import { render } from "./WizardSection.vue?vue&type=template&id=5b2b16be"
import script from "./WizardSection.vue?vue&type=script&lang=js"
export * from "./WizardSection.vue?vue&type=script&lang=js"

import "./WizardSection.vue?vue&type=style&index=0&id=5b2b16be&lang=scss"

import exportComponent from "/app/tmp/origina/V3/v2026.11.r3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__